import React from 'react';

import { ProfileEditForm, ProfileEditFormProps } from './ProfileEditForm';

/**
 * Props for UserProfileEditForm (excludes `type` since it's fixed to 'user')
 */
export type UserProfileEditFormProps = Omit<ProfileEditFormProps, 'type'>;

/**
 * User profile edit form
 *
 * Modal form for editing user profile picture and display name.
 * Thin wrapper around ProfileEditForm with type="user".
 *
 * Features:
 * - Profile picture upload with delete support
 * - Display name text input
 * - Loading states for both operations
 * - Disabled submit when no changes made
 *
 * Used in:
 * - UserSettingsCards via ScanSettingCard editConfig
 *
 * @see ProfileEditForm for implementation details
 */
export const UserProfileEditForm: React.FC<
  UserProfileEditFormProps
> = props => <ProfileEditForm type="user" {...props} />;
